import { DataController } from "./data-controller";

export class MainView {

    constructor() {
        this.controller = new DataController();
        this.NavDugmici = [];
        this.slideIndex = 0;
        var that = this;
    }

    RenderujStaickiPrikaz() {
        this.RenderujNavMenu(document.body);

        let maincontent = document.createElement('div');
        maincontent.className = "MainContainer";
        maincontent.id = "glavni_kontejner";
        document.body.appendChild(maincontent);

        this.RenderujHomepage(maincontent);

        this.RenderujFooter(document.body);
    }

    RenderujNavMenu(root) {
        let div_za_nav = document.createElement('nav');
        div_za_nav.className = "topnav";
        div_za_nav.id = "myTopnav";
        root.appendChild(div_za_nav);

        let a_menu = document.createElement('a');
        a_menu.className = "icon";
        a_menu.onclick = () => { this.KlikNaMenu(); };
        a_menu.innerHTML = "&#9776;";

        let a_homepage = document.createElement('a');
        a_homepage.innerHTML = "Početna";
        a_homepage.className = "primary";
        a_homepage.id = "link_pocetna";
        a_homepage.className += " active";
        a_homepage.onclick = (() => {
            this.ObojiOdabranuStranicu(a_homepage);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujHomepage(main_container);
        })

        let a_about = document.createElement('a');
        a_about.innerHTML = "O proizvodu";
        a_about.id = "link_about";
        a_about.className = "primary";
        a_about.onclick = (() => {
            this.ObojiOdabranuStranicu(a_about);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujAbout(main_container);
        })

        let a_podrska = document.createElement('a');
        a_podrska.innerHTML = "Podrška";
        a_podrska.id = "link_podrska";
        a_podrska.className = "primary";
        a_podrska.onclick = (() => {
            this.ObojiOdabranuStranicu(a_podrska);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujPodrska(main_container);
        })

        let a_pricing = document.createElement('a');
        a_pricing.innerHTML = "Licenca";
        a_pricing.id = "link_pricing";
        a_pricing.className = "primary";
        a_pricing.onclick = (() => {
            this.ObojiOdabranuStranicu(a_pricing);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujPricing(main_container);
        })

        let a_registracija = document.createElement('a');
        a_registracija.innerHTML = "Prijava";
        a_registracija.className = "primary";
        a_registracija.id = "link_registracija";
        a_registracija.onclick = (() => {
            this.ObojiOdabranuStranicu(a_registracija);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujRegistracijuIliLogin(main_container);
        })

        let logo = document.createElement('img');
        logo.onclick = () => { document.getElementById('link_pocetna').click(); };
        logo.src = "./resources/logo.png";

        let naziv = document.createElement('div');
        naziv.onclick = () => { document.getElementById('link_pocetna').click(); };
        naziv.id = "naziv";
        naziv.innerText = "Swift Service";

        div_za_nav.appendChild(logo);
        div_za_nav.appendChild(naziv);

        div_za_nav.appendChild(a_registracija);
        div_za_nav.appendChild(a_pricing);
        div_za_nav.appendChild(a_podrska);
        div_za_nav.appendChild(a_about);
        div_za_nav.appendChild(a_homepage);
        div_za_nav.appendChild(a_menu);

        this.NavDugmici.push(a_registracija);
        this.NavDugmici.push(a_pricing);
        this.NavDugmici.push(a_podrska);
        this.NavDugmici.push(a_about);
        this.NavDugmici.push(a_homepage);

        let a_homepage1 = document.createElement('a');
        a_homepage1.className = "secondary";
        a_homepage1.innerHTML = "Početna";
        a_homepage1.id = "link_pocetna1";
        a_homepage1.onclick = (() => {
            this.ObojiOdabranuStranicu(a_homepage1);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujHomepage(main_container);
        })

        let a_about1 = document.createElement('a');
        a_about1.className = "secondary";
        a_about1.innerHTML = "O proizvodu";
        a_about1.id = "link_about1";
        a_about1.onclick = (() => {
            this.ObojiOdabranuStranicu(a_about1);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujAbout(main_container);
        })

        let a_podrska1 = document.createElement('a');
        a_podrska1.innerHTML = "Podrška";
        a_podrska1.className = "secondary";
        a_podrska1.id = "link_podrska1";
        a_podrska1.onclick = (() => {
            this.ObojiOdabranuStranicu(a_podrska1);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujPodrska(main_container);
        })

        let a_pricing1 = document.createElement('a');
        a_pricing1.innerHTML = "Licenca";
        a_pricing1.className = "secondary";
        a_pricing1.id = "link_pricing1";
        a_pricing1.onclick = (() => {
            this.ObojiOdabranuStranicu(a_pricing1);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujPricing(main_container);
        })

        let a_registracija1 = document.createElement('a');
        a_registracija1.innerHTML = "Prijava";
        a_registracija1.className = "secondary";
        a_registracija1.id = "link_registracija1";
        a_registracija1.onclick = (() => {
            this.ObojiOdabranuStranicu(a_registracija1);
            let main_container = document.getElementById("glavni_kontejner");
            this.RenderujRegistracijuIliLogin(main_container);
        })

        div_za_nav.appendChild(a_homepage1);
        div_za_nav.appendChild(a_about1);
        div_za_nav.appendChild(a_podrska1);
        div_za_nav.appendChild(a_pricing1);
        div_za_nav.appendChild(a_registracija1);

        this.NavDugmici.push(a_registracija1);
        this.NavDugmici.push(a_pricing1);
        this.NavDugmici.push(a_podrska1);
        this.NavDugmici.push(a_about1);
        this.NavDugmici.push(a_homepage1);
    }

    //Renderovanje samih stranica
    RenderujHomepage(root) {
        this.IzbrisiDecu(root);

        let div_za_sliku = document.createElement('div');
        div_za_sliku.id = "div_za_sliku";
        root.appendChild(div_za_sliku);
        div_za_sliku.style.backgroundImage = "url(./resources/barman2.jpg)";

        let div_centralni = document.createElement('div');
        div_centralni.className = "centralni_div";
        div_za_sliku.appendChild(div_centralni);

        let logo = document.createElement('img');
        logo.src = "./resources/logo.png";
        div_centralni.appendChild(logo);

        let slogan = document.createElement('h1');
        slogan.innerText = "Brža usluga, veća zarada.";
        div_centralni.appendChild(slogan);

        let dugme_oproizvodu = document.createElement('button');
        dugme_oproizvodu.id = "dugme_oproizvodu";
        dugme_oproizvodu.innerText = "Saznaj više";
        dugme_oproizvodu.onclick = () => { document.getElementById('link_about').click(); };
        div_centralni.appendChild(dugme_oproizvodu);
    }
    RenderujAbout(root) {
        this.IzbrisiDecu(root);

        let div_content_about = document.createElement('div');
        div_content_about.className = "tekstualni_sadrzaj";
        root.appendChild(div_content_about);

        this.DodajSlajder(div_content_about, 13);
        this.DodajTacke(div_content_about, 13);
        this.PokreniSlajder(4, 0);

        let div_cont = document.createElement('div');
        root.appendChild(div_cont);

        div_cont.appendChild(document.createElement('br'));
        let naslov = document.createElement('h2');
        naslov.id = "veci_razmak_naslov";
        naslov.innerText = "Swift Service";
        div_cont.appendChild(naslov);

        let text = document.createElement('p');
        text.innerText = "SwiftService predstavlja softverski paket čija je namena efikasno i transparentno upravljanje radom srednjih i većih ugostiteljskih objekata. Bez obzira na delatnost i veličinu, svaki korak u poslovanju ozbiljnog preduzeća treba da bude propraćen kroz odgovarajući informacioni sistem. Prava informacija u pravom trenutku preduslov je za uspešan posao.";
        div_cont.appendChild(text);

        let tekst2 = document.createElement('p');
        tekst2.innerText = "Swift Service je softverski paket koji se sastoji od android aplikacija koje ubrzavaju rad konobara, kuhinje, šanka kao i desktop aplikacije koja ima ulogu u organizovanju i praćenju rada osoblja. Naš sistem garantuje ubrzannje rada objekta kao i transparentni prikaz rada lokala vlasniku lokala. Karakteristični sadržaji kojima se rad objekta prezentuje su osnovni podaci o objektu, podaci o osoblju i strukturi objekta, podaci o trenutnim narudžbinama i njihovom trenutnom stanju (da li je narudžbina spremna ili ne), kao i istorija poslovanja objekta - podaci o svim prethodnim računima. ";
        div_cont.appendChild(tekst2);

        let tekst3 = document.createElement('p');
        tekst3.innerText = "Potencijalni korisnici sistema su srednji i veći ugostiteljski objekti. Uređajima koji su u sklopu našeg paketa će upravljati edukovani članovi osoblja sa pravom pristupa sistemu. Kao rezultat, SwiftService sistem je projektovan da bude fleksibilan i proširiv za korišćenje  u različitim ugostiteljskim objektima. ";
        div_cont.appendChild(tekst3);

        this.DodajTeamSharpDiv(div_cont,"ts_div");
        
    }
    RenderujPodrska(root) {
        this.IzbrisiDecu(root);

        let div_content_podrska = document.createElement('div');
        div_content_podrska.id = "div_sadrzaj_podrska";
        div_content_podrska.className = "tekstualni_sadrzaj";
        root.appendChild(div_content_podrska);

        let ikonica = document.createElement('img');
        ikonica.src = "./resources/support.png";
        ikonica.className = "ikonica";
        div_content_podrska.appendChild(ikonica);

        let naslov = document.createElement('h2');
        naslov.innerText = "Tehnička podrška";
        div_content_podrska.appendChild(naslov);

        let tekst = document.createElement('p');
        tekst.innerText = "Tehnička podrška za naše korisnike je dostupna radnim danima od 9 do 19h, kao i subotom od 10 do 15h i pruža se putem emaila i portala za podršku. Podrška se pruža isključivo na ovaj način iz bezbednosnih razloga, odnosno zbog identifikacije korisnika i evidencije zahteva i naših postupaka, kao i u cilju boljeg praćenja komunikacije.";
        div_content_podrska.appendChild(tekst);

        let div_forma_tiket = document.createElement('div');
        div_forma_tiket.id = "div_forma_tiket";
        div_forma_tiket.className = "forma";
        root.appendChild(div_forma_tiket);

        let naslov_tiket = document.createElement('h3');
        naslov_tiket.innerText = "Tiket";
        div_forma_tiket.appendChild(naslov_tiket);

        this.DodajLabelu(div_forma_tiket, "Vaša email adresa");
        this.DodajInput(div_forma_tiket, "input_podrska_email");

        this.DodajLabelu(div_forma_tiket, "Naslov");
        this.DodajInput(div_forma_tiket, "input_podrska_naslov");

        this.DodajLabelu(div_forma_tiket, "Opis problema");
        let input_opis = document.createElement('textarea');
        input_opis.id = "input_podrska_opis";
        input_opis.onclick = () => { document.getElementById("input_podrska_opis").style.borderColor = ""; };
        div_forma_tiket.appendChild(input_opis);

        let dugme_posalji_tiket = document.createElement('button');
        dugme_posalji_tiket.className = "plavo_dugme";
        dugme_posalji_tiket.innerText = "Pošalji";
        dugme_posalji_tiket.onclick = () => {

            var naslov = document.getElementById('input_podrska_naslov').value;
            var email = document.getElementById('input_podrska_email').value;
            var opis = document.getElementById('input_podrska_opis').value;

            if (naslov != "" && email != "" && opis != "") {
                this.controller.postaviTiket(naslov, opis, email).then((data) => {
                    if (data == "1") {
                        document.getElementById('dodavanje_tiketa_alert').style.display = "block";

                        document.getElementById('input_podrska_naslov').value = "";
                        document.getElementById('input_podrska_email').value = "";
                        document.getElementById('input_podrska_opis').value = "";
                    }
                });
            }
            else {
                document.getElementById('dodavanje_tiketa_alert').style.display = "none";

                if (document.getElementById('input_podrska_naslov').value == "") {
                    document.getElementById('input_podrska_naslov').style.borderColor = "#ff0000";
                }
                if (document.getElementById('input_podrska_email').value == "") {
                    document.getElementById('input_podrska_email').style.borderColor = "#ff0000";
                }
                if (document.getElementById('input_podrska_opis').value == "") {
                    document.getElementById('input_podrska_opis').style.borderColor = "#ff0000";
                }
            }
        }
        div_forma_tiket.appendChild(dugme_posalji_tiket);

        this.DodajAlertBox(div_forma_tiket, "dodavanje_tiketa_alert", "S", "Uspešno dodavanje.");

    }
    RenderujPricing(root) {
        this.IzbrisiDecu(root);

        let div_content_pricing = document.createElement('div');
        div_content_pricing.id = "div_sadrzaj_pricing";
        div_content_pricing.className = "tekstualni_sadrzaj";
        root.appendChild(div_content_pricing);

        let ikonica = document.createElement('img');
        ikonica.src = "./resources/Licenca.png";
        ikonica.className = "ikonica";
        div_content_pricing.appendChild(ikonica);

        let naslov = document.createElement('h2');
        naslov.innerText = "Licenca";
        div_content_pricing.appendChild(naslov);

        let tekst = document.createElement('p');
        tekst.innerText = "Naš proizvod možete probati potpuno besplatno. Trial period traje 3 meseca. Ukoliko želite da probate ili kupite naš proizvod, kontaktirajte nas slanjem emaila ili pozivom.";
        div_content_pricing.appendChild(tekst);

        this.DodajLabelu(div_content_pricing, "Cena Swift Service paketa zavisi od veličine vašeg objekta, kao i od broja radnika. Uz softver, u našoj ponudi možete naći i odgovarajuće hardverske uređaje neophodne za sve servise koje Swift Service pruža. Plaćanje se može obaviti platnom karticom na sajtu, gotovinskom uplatom u bilo kojoj pošti ili banci, e-bank nalogom, virmanom ili deviznim transferom iz inostranstva.");

        this.DodajSiviDivKontakt(root,"sivi_div_kontakt");

        this.DodajDownloadsDiv(root,"div_downloads");
    }
    RenderujRegistracijuIliLogin(root) {
        this.IzbrisiDecu(root);

        if (!this.controller.logedin)
            this.RenderujLogin(root);
        else
            this.RenderujRegistraciju(root);
    }
    RenderujLogin(root) {

        this.IzbrisiDecu(root);

        let div_content_login = document.createElement('div');
        div_content_login.id = "div_sadrzaj_login";
        div_content_login.className = "tekstualni_sadrzaj";
        root.appendChild(div_content_login);

        let ikonica = document.createElement('img');
        ikonica.src = "./resources/katanac.png";
        ikonica.className = "ikonica";
        div_content_login.appendChild(ikonica);

        let naslov = document.createElement('h2');
        naslov.innerText = "Registracija novih korisnika";
        div_content_login.appendChild(naslov);

        this.DodajLabelu(div_content_login, "Registracija novih korisnika omogućena je samo privilegovanim korisnicima. Potrebna je prijava.");

        let div_content_registracija = document.createElement('div');
        div_content_registracija.className = "forma";
        root.appendChild(div_content_registracija);

        let naslov_prijava = document.createElement('h3');
        naslov_prijava.innerText = "Prijava administratora";
        div_content_registracija.appendChild(naslov_prijava);

        this.DodajLabelu(div_content_registracija, "Korisničko ime");
        this.DodajInput(div_content_registracija, "input_username_login");

        this.DodajLabelu(div_content_registracija, "Lozinka");
        this.DodajInput(div_content_registracija, "input_password_login");
        document.getElementById("input_password_login").type="password";

        let button_prijavi_se = document.createElement('button');
        button_prijavi_se.innerText = "Prijavi se";
        button_prijavi_se.className = "plavo_dugme";
        button_prijavi_se.onclick = () => {
            let username = document.getElementById('input_username_login').value;
            let password = document.getElementById('input_password_login').value;

            this.controller.loginUser(username, password).then((value) => {
                if (value == '1') {
                    this.controller.logedin = 1;
                    this.RenderujRegistraciju(root);
                }
                else {
                    document.getElementById('input_username_login').value = "";
                    document.getElementById('input_password_login').value = "";
                    document.getElementById("prijava_alert_red").style.display = "block";
                }
            });
        };
        div_content_registracija.appendChild(button_prijavi_se);

        this.DodajAlertBox(div_content_registracija, "prijava_alert_red", "A", "Pogrešno korisničko ime ili lozinka.");
    }
    RenderujRegistraciju(root) {
        this.IzbrisiDecu(root);

        let div_content_reg = document.createElement('div');
        div_content_reg.id = "div_sadrzaj_reg";
        div_content_reg.className = "tekstualni_sadrzaj";
        root.appendChild(div_content_reg);

        let ikonica = document.createElement('img');
        ikonica.src = "./resources/korisnik.png";
        ikonica.className = "ikonica";
        div_content_reg.appendChild(ikonica);

        let naslov = document.createElement('h2');
        naslov.innerText = "Registracija novih klijenata";
        div_content_reg.appendChild(naslov);

        this.DodajLabelu(div_content_reg, "Registracija novih klijenata je omogućena. Potrebno je popuniti sva polja u formi ispod.");

        let div_content_registracija = document.createElement('div');
        div_content_registracija.className = "forma";
        root.appendChild(div_content_registracija);

        this.DodajLabelu(div_content_registracija, "Registracija novog klijenta");

        let podnaslov_firma = document.createElement('h4');
        podnaslov_firma.innerText = "Podaci o firmi";
        div_content_registracija.appendChild(podnaslov_firma);

        this.DodajLabelu(div_content_registracija, "Naziv");
        this.DodajInput(div_content_registracija, "input_naziv_firme_registracija");

        this.DodajLabelu(div_content_registracija, "Adresa");
        this.DodajInput(div_content_registracija, "input_adresa_firme_registracija");

        this.DodajLabelu(div_content_registracija, "Kontakt telefon");
        this.DodajInput(div_content_registracija, "input_kontakt_firme_registracija");

        this.DodajLabelu(div_content_registracija, "Kontakt email");
        this.DodajInput(div_content_registracija, "input_kontakt_email_firme_registracija");

        this.DodajLabelu(div_content_registracija, "PIB");
        this.DodajInput(div_content_registracija, "input_pib_registracija");

        this.DodajLabelu(div_content_registracija, "MB");
        this.DodajInput(div_content_registracija, "input_mb_registracija");

        let podnaslov_vlasnik = document.createElement('h4');
        podnaslov_vlasnik.innerText = "Podaci o vlasniku";
        div_content_registracija.appendChild(podnaslov_vlasnik);

        this.DodajLabelu(div_content_registracija, "Ime");
        this.DodajInput(div_content_registracija, "input_ime_registracija");

        this.DodajLabelu(div_content_registracija, "Prezime");
        this.DodajInput(div_content_registracija, "input_prezime_registracija");

        this.DodajLabelu(div_content_registracija, "Adresa");
        this.DodajInput(div_content_registracija, "input_adresa_vlasnika_registracija");

        this.DodajLabelu(div_content_registracija, "Telefon");
        this.DodajInput(div_content_registracija, "input_telefon_vlasnika_registracija");

        this.DodajLabelu(div_content_registracija, "Email");
        this.DodajInput(div_content_registracija, "input_email_vlasnika_registracija");

        this.DodajLabelu(div_content_registracija, "Korisničko ime");
        this.DodajInput(div_content_registracija, "input_username_registracija");

        this.DodajLabelu(div_content_registracija, "Lozinka");
        this.DodajInput(div_content_registracija, "input_lozinka_registracija");

        let button_prijavi_se = document.createElement('button');
        button_prijavi_se.innerText = "Registruj";
        button_prijavi_se.className = "plavo_dugme";
        div_content_registracija.appendChild(button_prijavi_se);
        button_prijavi_se.onclick = () => {
            var naziv_f = document.getElementById('input_naziv_firme_registracija').value;
            var adresa_f = document.getElementById('input_adresa_firme_registracija').value;
            var telefon_f = document.getElementById('input_kontakt_firme_registracija').value;
            var email_f = document.getElementById('input_kontakt_email_firme_registracija').value;
            var pib_f = document.getElementById('input_pib_registracija').value;
            var mb_f = document.getElementById('input_mb_registracija').value;

            var ime_v = document.getElementById('input_ime_registracija').value;
            var prezime_v = document.getElementById('input_prezime_registracija').value;
            var adresa_v = document.getElementById('input_adresa_vlasnika_registracija').value;
            var telefon_v = document.getElementById('input_telefon_vlasnika_registracija').value;
            var email_v = document.getElementById('input_email_vlasnika_registracija').value;
            var username_v = document.getElementById('input_username_registracija').value;
            var lozinka_v = document.getElementById('input_lozinka_registracija').value;

            var SHA256 = require("crypto-js/sha256");
            lozinka_v = SHA256(lozinka_v).toString();

            if (naziv_f != "" && adresa_f != "" && telefon_f != "" && email_f != "" && pib_f != "" && mb_f != "" && ime_v != "" && prezime_v != "" && adresa_v != "" && telefon_v != "" && email_v != "" && username_v != "" && lozinka_v) {
                this.controller.registrujFirmu(naziv_f, adresa_f, telefon_f, email_f, pib_f, mb_f, ime_v, prezime_v, adresa_v, telefon_v, email_v, username_v, lozinka_v).then((result) => {
                    if (result == 1) {
                        document.getElementById('input_naziv_firme_registracija').value = "";
                        document.getElementById('input_adresa_firme_registracija').value = "";
                        document.getElementById('input_kontakt_firme_registracija').value = "";
                        document.getElementById('input_kontakt_email_firme_registracija').value = "";
                        document.getElementById('input_pib_registracija').value = "";
                        document.getElementById('input_mb_registracija').value = "";

                        document.getElementById('input_ime_registracija').value = "";
                        document.getElementById('input_prezime_registracija').value = "";
                        document.getElementById('input_adresa_vlasnika_registracija').value = "";
                        document.getElementById('input_telefon_vlasnika_registracija').value = "";
                        document.getElementById('input_email_vlasnika_registracija').value = "";
                        document.getElementById('input_username_registracija').value = "";
                        document.getElementById('input_lozinka_registracija').value = "";

                        document.getElementById("alert_registracija_zeleno").style.display = "block";
                        document.getElementById("alert_registracija_crveno").style.display = "none";
                    }
                    else {
                        document.getElementById("alert_registracija_crveno").style.display = "block";
                        document.getElementById("alert_registracija_zeleno").style.display = "none";
                    }
                });
            }
            else {
                if (naziv_f == "")
                    document.getElementById('input_naziv_firme_registracija').style.borderColor = "#ff0000";
                if (adresa_f == "")
                    document.getElementById('input_adresa_firme_registracija').style.borderColor = "#ff0000";
                if (telefon_f == "")
                    document.getElementById('input_kontakt_firme_registracija').style.borderColor = "#ff0000";
                if (email_f == "")
                    document.getElementById('input_kontakt_email_firme_registracija').style.borderColor = "#ff0000";
                if (pib_f == "")
                    document.getElementById('input_pib_registracija').style.borderColor = "#ff0000";
                if (mb_f == "")
                    document.getElementById('input_mb_registracija').style.borderColor = "#ff0000";

                if (ime_v == "")
                    document.getElementById('input_ime_registracija').style.borderColor = "#ff0000";
                if (prezime_v == "")
                    document.getElementById('input_prezime_registracija').style.borderColor = "#ff0000";
                if (adresa_v == "")
                    document.getElementById('input_adresa_vlasnika_registracija').style.borderColor = "#ff0000";
                if (telefon_v == "")
                    document.getElementById('input_telefon_vlasnika_registracija').style.borderColor = "#ff0000";
                if (email_v == "")
                    document.getElementById('input_email_vlasnika_registracija').style.borderColor = "#ff0000";
                if (username_v == "")
                    document.getElementById('input_username_registracija').style.borderColor = "#ff0000";
                if (document.getElementById('input_lozinka_registracija').value == "")
                    document.getElementById('input_lozinka_registracija').style.borderColor = "#ff0000";

                document.getElementById("alert_registracija_crveno").style.display = "none";
                document.getElementById("alert_registracija_zeleno").style.display = "none";
            }
        };

        this.DodajAlertBox(div_content_registracija, "alert_registracija_zeleno", "S", "Novi klijent je uspešno dodat.");
        this.DodajAlertBox(div_content_registracija, "alert_registracija_crveno", "A", "Došlo je do greške");
    }
    RenderujFooter(root) {
        var footerel = document.createElement('footer');
        root.appendChild(footerel);

        var psoft = document.createElement('p');
        psoft.innerHTML = '©2017 Team Sharp';

        footerel.appendChild(psoft);
    }

    IzbrisiDecu(root) {
        while (root.children.length > 0) {
            for (var i = 0; i < root.children.length; i++) {
                root.removeChild(root.children[i]);
            }
        }
    }
    ObojiOdabranuStranicu(clicked_link) {
        this.NavDugmici.forEach(item => {
            item.className = item.className.replace(" active", "");
            if (item.id == clicked_link.id) {
                item.className += " active";
            }
        });
    }

    DodajLabelu(root, text) {
        let labela = document.createElement('p');
        labela.innerText = text;
        root.appendChild(labela);
    }
    DodajInput(root, id) {
        let input = document.createElement('input');
        input.id = id;
        input.onclick = () => { document.getElementById(id).style.borderColor = ""; };
        root.appendChild(input);
    }
    DodajSiviDivKontakt(root, id){
        let sivi_div = document.createElement('div');
        sivi_div.id = id;
        sivi_div.className = "sivi_div";
        root.appendChild(sivi_div);

        let naslov = document.createElement('h2');
        naslov.innerText="Kontakt informacije";
        sivi_div.appendChild(naslov);

        this.DodajKontaktKomponentu(sivi_div, "./resources/slusalica.png", "+381666625349");
        this.DodajKontaktKomponentu(sivi_div, "./resources/email.png", "sales@psoftwarestudio.com");
    }
    DodajKontaktKomponentu(root, imagesrc, labeltext) {
        let div_container = document.createElement('div');
        div_container.className = "kontakt_komponenta";
        root.appendChild(div_container);

        let slika = document.createElement('img');
        slika.src = imagesrc;
        div_container.appendChild(slika);

        this.DodajLabelu(div_container, labeltext);
    }

    DodajDownloadsDiv(root, id){
        
        let div_za_naslov = document.createElement('div');
        div_za_naslov.className = "div_za_naslov_downloads";
        root.appendChild(div_za_naslov);

        let naslov = document.createElement('h2');
        naslov.innerText = "Preuzimanja";
        naslov.id="downloads_naslov";
        div_za_naslov.appendChild(naslov);

        let ddiv = document.createElement('div');
        ddiv.className = 'downloads_div';
        ddiv.id = id;

        let opis = "Windows aplikacija za menadžera objekta. Pomoću ove aplikacije menadžer ili vlasnik ima mogućnost manipulacije naloga osoblja rasporedu stolova, primanjem zahteva za računima i drugo.";
        this.DodajDonwloadComponentu(ddiv,"download_admin","SwiftAdmin",opis,"./resources/windows.png","./Downloads/SwiftAdmin.msi");

        opis = "Android aplikacija namenjena konobarima. Preko ove aplikacije konobari mogu da kreiraju nove porudžbine za stolove koji su im dodeljeni, da šalju zahtev za ispostavu računa i drugo.";
        this.DodajDonwloadComponentu(ddiv,"download_konobar","SwiftKonobar",opis,"./resources/android.png","./Downloads/SwiftKonobar.apk");

        opis = "Android aplikacija namenjena šefu kuhinje. Pomoću ove aplikacije šef kuhinje prima narudžbine, obaveštava o njihovoj spremnosti, ima mogućnost otkazivanja narudžbine i drugo.";
        this.DodajDonwloadComponentu(ddiv,"download_kuhinja","SwiftKuhinja",opis,"./resources/android.png","./Downloads/SwiftKuhinja.apk");

        opis = "Android aplikacija namenjena šankerima. Pomoću ove aplikacije šankeri primaju narudžbine, obaveštava o njihovoj spremnosti, imaju mogućnost otkazivanja narudžbine i drugo.";
        this.DodajDonwloadComponentu(ddiv,"download_sank","SwiftSank",opis,"./resources/android.png","./Downloads/SwiftSank.apk");

        root.appendChild(ddiv);
    }
    DodajDonwloadComponentu(root, id, naslov, tekst, srcimage, lokacija_fajla){
        let div_kont = document.createElement('div');
        div_kont.id = id;
        div_kont.className = "donwload_komponenta";
        root.appendChild(div_kont);

        let slikai = document.createElement('img');
        slikai.src = './resources/tinyswift.png';
        div_kont.appendChild(slikai);
        

        let naslovd = document.createElement('h3');
        naslovd.innerText = naslov;
        div_kont.appendChild(naslovd);

        let opis = document.createElement('p');
        opis.innerText = tekst;
        div_kont.appendChild(opis);

        let plavo_dugme = document.createElement('a');
        plavo_dugme.innerText = "Preuzmi";
        plavo_dugme.className = "plavi_link";        
        div_kont.appendChild(plavo_dugme);
        plavo_dugme.href = lokacija_fajla;

        let slika = document.createElement('img');
        slika.src = srcimage;
        div_kont.appendChild(slika);
    }

    DodajTeamSharpDiv(root, id){
        let div_cont = document.createElement('div');
        div_cont.id=id;
        div_cont.className = "maincontainer_person";
        root.appendChild(div_cont);

        let naslov = document.createElement('h2');
        naslov.innerText = "Team Sharp";
        div_cont.appendChild(naslov);

        this.DodajOsobaComponentu(div_cont,"./resources/petar.jpg","Petar Mijović",".NET, Android, Web");
        this.DodajOsobaComponentu(div_cont,"./resources/mladen.jpg","Mladen Milošević",".NET, Android");
        this.DodajOsobaComponentu(div_cont,"./resources/nikola.jpg","Nikola Lugić",".NET, Android");
        this.DodajOsobaComponentu(div_cont,"./resources/melanija.jpg","Melanija Krstojević",".NET, Android");
    }
    DodajOsobaComponentu(root,imgsrc,ime,kval){
        let div_cont = document.createElement('div');
        div_cont.className = "container_person";
        root.appendChild(div_cont);

        let slika = document.createElement('img');
        slika.src = imgsrc;
        slika.alt = "Avatar";
        slika.className = "image_person";
        div_cont.appendChild(slika);

        let overlay = document.createElement('div');
        overlay.className = "overlay_person";
        div_cont.appendChild(overlay);

        let overlay_text = document.createElement('div');
        overlay_text.innerText = ime;
        overlay_text.className = "overlay_text_person";
        overlay.appendChild(overlay_text);

        let text = document.createElement('p');
        text.innerText = kval;
        div_cont.appendChild(text);
    }

    DodajSlajd(root, index, count, imgsource, nazivslajda) {

        let div_slajd = document.createElement('div');
        div_slajd.className = "mySlides fade";
        root.appendChild(div_slajd);

        let div_numtext = document.createElement('div');
        div_slajd.appendChild(div_numtext);
        div_numtext.innerText = index + "/" + count;
        div_numtext.className = "numbertext";

        let slika = document.createElement('img');
        slika.className = "slika_slajdera";
        slika.src = imgsource;
        div_slajd.appendChild(slika);

        let naziv = document.createElement('div');
        naziv.className = "text";
        naziv.innerText = nazivslajda;
        div_slajd.appendChild(naziv);
    }
    DodajSlajder(root, imgcount) {
        let div_slider_container = document.createElement('div');
        div_slider_container.className = "slideshot-container";
        root.appendChild(div_slider_container);

        for (var i = 0; i < imgcount; i++) {
            var ind = i + 1;
            this.DodajSlajd(div_slider_container, i + 1, imgcount, "./resources/" + ind + ".png", "Slide " + ind);
        }

        let a_prev = document.createElement('a');
        div_slider_container.appendChild(a_prev);
        a_prev.innerHTML = "&#10094";
        a_prev.className = "prev";

        let a_next = document.createElement('a');
        div_slider_container.appendChild(a_next);
        a_next.innerHTML = "&#10095";
        a_next.className = "next";
    }
    DodajTacke(root, imgcount) {
        let container_tackica = document.createElement('div');
        container_tackica.className = "dot_cont";
        root.appendChild(container_tackica);

        for (var i = 0; i < imgcount; i++) {
            let span = document.createElement('span');
            span.className = "dot";
            container_tackica.appendChild(span);
        }
    }
    DodajAlertBox(root, id, type, tekst) {
        let div_za_alert = document.createElement('div');
        root.appendChild(div_za_alert);
        div_za_alert.className = "alert";
        div_za_alert.id = id;

        let strong = document.createElement('strong');
        strong.innerText = tekst
        div_za_alert.appendChild(strong);

        let span = document.createElement('span');
        span.className = "closebtn";
        span.onclick = () => { document.getElementById(id).style.display = 'none'; }
        span.innerHTML = "&times";
        div_za_alert.appendChild(span);

        if (type == "A") { //alert
            div_za_alert.style.backgroundColor = "#f44336";
        }
    }
    PokreniSlajder(n, ind) {
        var i;
        var slides = document.getElementsByClassName("mySlides");
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        ind++;
        this.slideIndex = ind;
        if (ind > slides.length) { ind = 1 }
        slides[ind - 1].style.display = "block";

        var dots = document.getElementsByClassName("dot");
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        dots[ind - 1].className += " active";

        this.Odspavaj().then(() => { this.PokreniSlajder(n, ind) })
    }
    Odspavaj() {
        return new Promise((resolve) => setTimeout(resolve, 4000));
    }

    KlikNaMenu() {
        var x = document.getElementById("myTopnav");
        if (x.className === "topnav") {
            x.className += " responsive";
            //ubaci u suprotnom redosledu
        } else {
            x.className = "topnav";
            //vrati u originalan redosled
        }
    }

}


// WEBPACK FOOTER //
// ./src/main-view.js